import "./Preloader.scss";

import React from "react";

export const Preloader = (): JSX.Element => (
  <div className="unit unit_preloader">
    <div className="loader" />
  </div>
);
